export default "__VITE_ASSET__BD8nn711__"